{
  "title": "如何建立評分規準（Rubric）",
  "description": "建立評分規準與評分項目，設定各項目的權重，供評審依此評分。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該場競賽有一份可指派給輪次的評分規準，評審會依此規準逐項評分。",
  "roleNote": "主辦方管理員",
  "prerequisites": ["已具備該競賽的管理權限", "已規劃好評分項目與各項配分"],
  "pathLabel": "主辦方主控台 → 競賽設定 → 評分規準",
  "steps": [
    {
      "title": "1. 建立評分規準",
      "description": "輸入評分規準名稱與說明，並新增至少一個評分項目，每個項目可設定名稱、說明、配分範圍（最低／最高分）與權重。每個評分項目還可新增「分數級距範例」（最低分、最高分與說明，最多 12 筆），評審評分時可展開查看。總分一律以 100 分為滿分：每個項目依「得分 ÷ 該項最高分 × 權重」換算，所以用 0 到 10 或 0 到 100 計分都可以。"
    },
    {
      "title": "2. 確認權重總和為 100",
      "description": "系統會驗證所有評分項目的權重加總是否恰好等於 100；不等於 100（無論多於或少於）都會被拒絕並提示錯誤，需調整各項目權重後才能送出。"
    },
    {
      "title": "3. 為版本命名（選填）",
      "description": "可為評分規準的個別版本加上識別名稱（例如「初賽」「決賽」），方便同一份規準在不同輪次沿用時能清楚區分；純粹是名稱標記，不會觸發複製新版本。"
    },
    {
      "title": "4. 綁定到輪次",
      "description": "在輪次設定中選擇要使用的評分規準，之後該輪次的每筆評審指派都會依此規準呈現評分表。"
    }
  ],
  "afterward": [
    "評分規準已建立，可在輪次設定中選用",
    "評審進入評分頁時會看到依此規準逐項列出的評分表"
  ],
  "nextSteps": "評分規準建立好後，請見「如何建立競賽輪次並設定時程」將其綁定到對應輪次，並見「如何邀請評審」開始邀請評審。",
  "faq": [
    {
      "q": "已經有評審開始評分後，還可以修改評分項目嗎？",
      "a": "可以，但系統會依是否已經有分數紀錄而有不同處理：若尚未有任何分數，替換評分項目會直接套用在原版本上；若已經有分數存在，系統會自動建立一個新版本（V+1）承載您的修改，既有分數所對應的舊版本內容維持不變，不會被覆蓋或竄改。"
    },
    {
      "q": "一場競賽只能有一份評分規準嗎？",
      "a": "不是，可以建立多份評分規準（例如初賽與決賽使用不同的評分項目），再分別綁定到對應的輪次。"
    },
    {
      "q": "評分規準的版本名稱有什麼作用？",
      "a": "版本名稱只是顯示用的識別標籤（例如區分「初賽」「決賽」版本），單純命名不會建立新版本或影響既有分數，是純粹的 metadata 調整。"
    }
  ]
}
